import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import KenTextLabel from '../KenTextLabel';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  errorStyles: {
    border: '1px solid red',
    padding: '8px',
    borderRadius: '4px',
  },
});

export default function KenRadioGroup(props) {
  const { label, row = true, options, required, optionalLabel, error, className, radioSx, labelClassName, ...otherProps } = props;
  const classes = useStyles();

  return (
    <FormControl>
      <Box component={'div'} className="d-flex flex-column" gap={'14px'}>
        <KenTextLabel label={label} required={required} optionalLabel={optionalLabel} labelClassName={labelClassName} />
        <RadioGroup row={row} aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group" {...otherProps} className={error ? classes.errorStyles : className}>
          {options?.map((option) => {
            return (
              <FormControlLabel
                sx={{
                  '.MuiFormControlLabel-label': {
                    fontSize: '16px',
                    fontWeight: '500',
                    color: '#333333',
                  },
                }}
                value={option?.value}
                control={<Radio />}
                label={option.label}
                {...option}
              />
            );
          })}
        </RadioGroup>
      </Box>
      {error && (
        <Typography variant="subtitle1" style={{ color: 'red' }} align="left">
          {error}
        </Typography>
      )}
    </FormControl>
  );
}
